

















































































































































































































































































































































































































import { computed, defineComponent, reactive } from "@vue/composition-api";
import {
  Button,
  Steps,
  InputContainer,
  SearchableSelect,
  auth,
} from "@micad/vue-components";
import { userCreate } from "@/data/repos/userCreate";
import { Application, getAppRoles, setUserRoles } from "@/data/repos/rolesList";
import { getUserDetailsConst } from "@/assets/js/constants";
import Vue from "vue";
import { getUserProfiles } from "@/data/repos/userDetails";
import router from "@/router";
import {
  QBadge,
  QBtn,
  QChip,
  QDate,
  QIcon,
  QInput,
  QPopupProxy,
  QSelect,
  QTime,
  QToggle,
} from "quasar";
import moment from "moment/moment";
import { canIUse } from "@/modules/auth";
import { getClientConfigValue } from "@/data/repos/clientConfig";
import { UserDetails } from "@/data/repos/commonModels";
import { setUserProfiles, userUpdate } from "@/data/repos/userUpdate";
import { ApiResponse } from "@/data/apiClient";

export default defineComponent({
  name: "UserCreate",
  methods: { canIUse },
  components: {
    QChip,
    QSelect,
    QToggle,
    QTime,
    QPopupProxy,
    QBtn,
    QInput,
    QIcon,
    QDate,
    Steps,
    InputContainer,
    SearchableSelect,
    Button,
    QBadge,
  },
  setup() {
    const steps = [
      { number: 1, title: "Details", current: true },
      { number: 2, title: "Access", current: false },
    ];
    const validators1 = reactive({
      userName: [
        (val: string) => !!val || "Username is required",
        (val: string) => val.length < 150 || "Value is too long",
      ],
      firstName: [
        (val: string) => !!val || "First name is required",
        (val: string) => val.length < 150 || "Value is too long",
      ],
      lastName: [
        (val: string) => !!val || "Last name is required",
        (val: string) => val.length < 150 || "Value is too long",
      ],
    });
    const validators2 = reactive({
      organisation: [(val: string) => val.length < 150 || "Value is too long"],
      position: [(val: string) => val.length < 150 || "Value is too long"],
      directory: [(val: string) => val.length < 150 || "Value is too long"],
    });
    const state = reactive({
      validators1,
      formValid1: computed(() => {
        for (const [key, vFuncs] of Object.entries(validators1))
          for (const f of vFuncs)
            if (f(String(state.userDetails[key as keyof UserDetails])) !== true)
              return false;
        return true;
      }),
      validators2,
      formValid2: computed(() => {
        for (const [key, vFuncs] of Object.entries(validators2))
          for (const f of vFuncs)
            if (f(String(state.userDetails[key as keyof UserDetails])) !== true)
              return false;
        return true;
      }),
      userDetails: getUserDetailsConst(),
      steps,
      showForms: true,
      applications: [] as Application[],
      serverErrorMessage: "",
      userProfileOptions: [] as { label?: string; value?: number }[],
      userProfilesSelected: [] as { label?: string; value?: number }[],
      showRoles: false,
      showProfiles: false,
      switchToStep,
      submit,
      resetForm,
      goBack: () => router.back(),
    });

    getClientConfigValue("HIDE_ROLES").then(
      (resp) =>
        (state.showRoles =
          (resp.payload?.value || "").toLocaleLowerCase() !== "y")
    );

    getClientConfigValue("HIDE_USER_PROFILES").then(
      (resp) =>
        (state.showProfiles =
          (resp.payload?.value || "").toLocaleLowerCase() !== "y")
    );

    setTimeout(async () => {
      const userProfiles = await getUserProfiles(true);
      if (userProfiles.ok)
        state.userProfileOptions = (userProfiles.payload || []).map((v) => ({
          label: v.name,
          value: v.id,
        }));
    }, 0);

    function switchToStep(newStep: number) {
      steps.forEach((step) => (step.current = step.number === newStep));
    }

    async function getAllAppRoles() {
      const appRoles = (await getAppRoles()).payload as Application[];
      return appRoles.map((app) => ({
        ...app,
        value: undefined,
        options: [
          { label: "None", value: -1 },
          ...app.roles.map((role) => ({
            label: role.name,
            value: role.id,
          })),
        ],
      }));
    }

    async function resetForm() {
      state.userDetails = getUserDetailsConst();
      state.applications = await getAllAppRoles();
      switchToStep(1);
      state.showForms = true;
    }

    setTimeout(async () => resetForm(), 0);

    async function saveRoles(userId: number) {
      const roleIds = state.applications
        .filter((v) => v.value)
        .map((app) => (app.value && app.value.value) || -1)
        .filter((v) => v > 0);
      return setUserRoles(userId, roleIds);
    }

    async function submit() {
      if (state.userDetails.micadUser && !state.userDetails.organisation)
        state.userDetails.organisation = "Micad";
      state.userDetails.roleIds = state.applications
        .filter((v) => v.value)
        .map((app) => (app.value && app.value.value) || -1);
      const resp = await userCreate({
        ...state.userDetails,
        expirationTimestamp: state.userDetails.expirationTimestamp
          ? moment(state.userDetails.expirationTimestamp, "YYYY/MM/DD HH:mm")
              .toDate()
              .toISOString()
          : undefined,
      });
      state.serverErrorMessage = "";
      const requests: Promise<ApiResponse<any>>[] = [];
      if (resp.ok) {
        requests.push(
          setUserProfiles(
            (resp.payload as { id: number }).id,
            state.userProfilesSelected.map((v) => v.value as number)
          )
        );
        requests.push(saveRoles((resp.payload as { id: number }).id));
        if (resp.payload && resp.payload.id > 0) {
          requests.push(
            userUpdate({
              ...state.userDetails,
              id: resp.payload.id,
              expirationTimestamp: state.userDetails.expirationTimestamp
                ? moment(
                    state.userDetails.expirationTimestamp,
                    "YYYY/MM/DD HH:mm"
                  )
                    .toDate()
                    .toISOString()
                : undefined,
            })
          );
        }
        await Promise.all(requests);
        state.showForms = false;
        Vue.$toast.success("User has been created");
        await router.push({
          name: "UserDetails",
          params: { id: String(resp.payload?.id), refresh: "true" },
        });
      } else {
        if (resp.response && resp.response.status < 500) {
          state.serverErrorMessage = resp.response.data.errorMessage;
          Vue.$toast.error(resp.response.data.errorMessage);
        } else {
          state.serverErrorMessage =
            "Failed to create user due to server error.";
          Vue.$toast.error("Failed to create user due to server error.");
        }
      }
    }

    return state;
  },
});
